import type { ReactNode } from 'react';

export const symbol_ecg_heart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-480Zm0 360q-18 0-34.5-6.5T416-146L148-415q-35-35-51.5-80T80-589q0-103 67-177t167-74q48 0 90.5 19t75.5 53q32-34 74.5-53t90.5-19q100 0 167.5 74T880-590q0 49-17 94t-51 80L543-146q-13 13-29 19.5t-34 6.5Zm40-510q8 0 14 4t11 10l71 106h188q8-19 12-39t4-41q0-77-50-133.5T645-780q-35 0-67.5 14.5T521-725l-27 29q-3 3-6 5t-8 2q-5 0-8.5-2t-6.5-5l-27-29q-24-26-56.5-40.5T314-780q-75 0-124.5 56.5T140-590q0 21 4 41t12 39h204q8 0 14.5 3.5T385-497l46 70 60-182q3-9 11-15t18-6Zm9 97-61 182q-3 9-11 15t-18 6q-8 0-14-4t-10-10l-71-106H198l261 261q5 5 10 7t11 2q6 0 11-2t10-7l260-261H600q-8 0-14-4t-11-10l-46-69Z"
		/>
	</svg>
);
